import { Node, Edge } from '@xyflow/react'

// Loose API shape; the strict Node/Edge types live in @xyflow/react.
type WorkflowNodeRecord = Record<string, unknown>
type WorkflowEdgeRecord = Record<string, unknown>

export const recordToNodes = (nodes: WorkflowNodeRecord[]): Node[] =>
  nodes.map((n) => ({
    id: String(n.id ?? ''),
    type: (n.type as string | undefined) ?? undefined,
    position: (n.position as { x: number; y: number } | undefined) ?? { x: 0, y: 0 },
    data: (n.data as Record<string, unknown>) ?? {},
  }))

export const recordToEdges = (edges: WorkflowEdgeRecord[]): Edge[] =>
  edges.map((e) => ({
    id: String(e.id ?? ''),
    source: String(e.source ?? ''),
    target: String(e.target ?? ''),
    sourceHandle: (e.sourceHandle as string | undefined) ?? undefined,
    targetHandle: (e.targetHandle as string | undefined) ?? undefined,
    type: (e.type as string | undefined) ?? 'workflow',
  }))

export const nodesToRecord = (nodes: Node[]): WorkflowNodeRecord[] =>
  nodes.map((n) => ({
    id: n.id,
    type: n.type ?? null,
    position: n.position,
    data: n.data,
  }))

export const edgesToRecord = (edges: Edge[]): WorkflowEdgeRecord[] =>
  edges.map((e) => ({
    id: e.id,
    source: e.source,
    target: e.target,
    sourceHandle: e.sourceHandle ?? null,
    targetHandle: e.targetHandle ?? null,
    type: e.type ?? null,
  }))
